<template>
  <div class="subPage">
    <!-- 面包屑 -->
    <bread-crumb>
      <el-breadcrumb-item to="/home">首页</el-breadcrumb-item>
      <el-breadcrumb-item>监督投诉</el-breadcrumb-item>
    </bread-crumb>
    <div class="contBox" v-if="companyInfo"  ref="contHtml" v-html="companyInfo.InforContent">
    </div>
  </div>
</template>

<script>
import { getInforList } from "@/api/index.js";
export default {
  name: "SubPage",
  data() {
    return {
      companyInfo: ""
    };
  },
  mounted() {
    this.getCompanyInfo();
  },
  updated() {
    let doms = this.$refs.contHtml.childNodes;
    console.log(doms);
    doms.forEach(element => {
      element.style.fontSize = '20px';
      element.style.fontFamily = '仿宋';
    });
 },
  methods: {
    getCompanyInfo() {
      let data = {
        ClassCode: "800007",
        PageIndex: 1,
        PageSize: 10,
        TenantID: this.$store.state.tenantid,
      };
      getInforList(data).then((res) => {
        if (res) {
          this.companyInfo = res.message?res.message[0]:"";
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.subPage {
  min-height: calc(100vh - 406px);
  padding-bottom: 20px;
  .contBox {
    width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 460px);
    padding-top: 10px;
    p {
      text-indent: 2em;
      line-height: 1.8;
    }
  }
}
</style>
